// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebaseConfig: {
    apiKey: "AIzaSyAGBe-hMFDSFTN13xa2d7FCKM5Vz9a8GWk",
    authDomain: "genteccloud.firebaseapp.com",
    databaseURL: "https://genteccloud.firebaseio.com",
    projectId: "genteccloud",
    storageBucket: "genteccloud.appspot.com",
    messagingSenderId: "76770980611"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 * SandBox
    apiKey: "AIzaSyD0V4nzj9Ay9bldK9_lvuce7qid6auhWWs",
    authDomain: "gentecsandbox.firebaseapp.com",
    databaseURL: "https://gentecsandbox.firebaseio.com",
    projectId: "gentecsandbox",
    storageBucket: "gentecsandbox.appspot.com",
    messagingSenderId: "704044488873"
  
 * BancoInternacional
    apiKey: "AIzaSyA9uZ6Y34r8PQuIXDHmeHOPk4Br1Yl_R68",
    authDomain: "bancointernacional.firebaseapp.com",
    databaseURL: "https://bancointernacional.firebaseio.com",
    projectId: "bancointernacional",
    storageBucket: "bancointernacional.appspot.com",
    messagingSenderId: "504435767523"
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
